import { Label, LabelValue, LabelType } from 'graphql/types';
import { FormTimesheetLabel } from '../../labelSchema';
export const filterLabelsByType = <T extends Label>(
  labels: T[],
  labelType: LabelType
): T[] => {
  return labels.filter((label: Label) => label.type === labelType);
};

export const filterFormLabelsByType = <T extends FormTimesheetLabel>(
  labels: T[],
  labelType: LabelType
): T[] => {
  return labels.filter(
    ({ label }: FormTimesheetLabel) => label.type === labelType
  );
};

export const isFormLabelType = <T extends FormTimesheetLabel>(
  formLabel: T,
  labelType: LabelType
): boolean => formLabel.label.type === labelType;

export const isLabelType = <T extends Label>(
  label: T,
  labelType: LabelType
): boolean => label.type === labelType;

export const mapDefaultValue = (
  label: Label,
  defaultValue: undefined | null
): LabelValue | undefined | null => {
  if (!label || !label.defaultValue) return defaultValue;
  return {
    idValue: label.defaultValue?.idValue,
    stringValue: label.defaultValue?.stringValue,
    numericValue: label.defaultValue?.numericValue || null
  };
};
